/** Cents as "$36" or "$36.50": whole dollars drop the cents so the tiles stay short. */
export const formatCents = (amountInCents: number) =>
	(amountInCents / 100).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: amountInCents % 100 === 0 ? 0 : 2,
		maximumFractionDigits: 2,
	})
